import { Box, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { Category } from '../../Utils/types';
import { Vocabulary } from '../../Utils/Vocabulary';

interface Props {
  categories: Category[];
  onSelect: (category: Category) => void;
}

export default function StepManufacturer({ categories, onSelect }: Props) {
  return (
    <Box>
      <Typography variant="h5" sx={{ textAlign: 'center' }} gutterBottom>{Vocabulary.stepManufacturer}</Typography>
      <Grid container spacing={3} mt={1}>
        {categories.map((category) => (
          <Grid item xs={6} lg={2} sm={6} md={4} key={category._id}>
            <Card
              elevation={2}
              sx={{ borderRadius: 2, 
              '&:hover': { boxShadow: 6 },
               height: '250px'}}
            >
              <CardActionArea
                onClick={() => onSelect(category)}
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}
              >
                <Box
                  component="img"
                  src={category.file}
                  alt={category.name}
                  sx={{ width: 80, height: 80, objectFit: 'contain', mb: 2 }}
                />
                <CardContent sx={{ pt: 0 }}>
                  <Typography variant="body1" align="center">{category.name}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
